import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

// The Table Component Test card's body on the Test UI Components page: a cs-table with a header row
// and clickable, selectable rows.
@Component({
  selector: 'cs-test-table-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-table-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestTableCardComponent {
  selectedTableRow: number | null = null;

  constructor(private cd: ChangeDetectorRef) {}

  // Table test methods
  onTableRowClick(rowIndex: number) {
    this.selectedTableRow = rowIndex;
    this.cd.markForCheck();
    console.log('Table row clicked:', rowIndex);
  }
}
